/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".runtime-info[_ngcontent-%COMP%]{padding:0 5px 1em 0;display:flex;align-items:center}.runtime-info[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{margin-right:10px;font-size:28px;width:28px;height:28px}"];
export { styles as styles };
